import React from "react";
import ReactTable from "react-table";
import {Col} from "react-bootstrap";
import {connect} from "react-redux";
import {confirmAlert} from "react-confirm-alert";
import {Link} from "react-router-dom";
import Confirmalertfordelete from "../../ThemeComponents/confirmAlertForDelete";
import downloadIcon from '../../../assets/img/download_icon.png';
import {createOrderActions} from "../../../redux/actions/create-order-actions";
import {CSVDownloader} from 'react-papaparse'

//import ReactDataToCSV from 'components/ThemeComponents/reactDataToCSV';

import $ from "jquery";

var moment = require("moment");

class ViewCartProductsList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            submitted: false,
            dataToDownload: [],
            products_data: [],
            all_checked: false,
            all_columns: [],
            exportAttsMap: {},
        };
    }

    deleteConfirmListItem(list_id, desc = "Are you sure to remove this product from shopping cart?") {
        confirmAlert({
            customUI: ({onClose}) => {
                return (
                    <Confirmalertfordelete
                        typeName="Product/s"
                        description={desc}
                        onClosePro={onClose}
                        deleteType={() =>
                            this.props.deleteProductFromCart(list_id).then(res => {
                                this.setState({
                                    all_checked: false,
                                })
                            })
                        }
                    />
                );
            }
        });
    }

    doFocus = (id) => {
        $(id).focus();
    }

    changeHandler2 = (e, id, index) => {
        this.props.changeHandler(e, id, index);
    };

    genTblInput = (col, myCol) => {
        const dataType = myCol.data_type === 'integer' ? 'number' : 'text';

        let defaultValue;
        if (myCol.data_type === 'string') {
            if (col.value === '0') {
                defaultValue = '';
            } else {
                defaultValue = col.value;
            }
        } else {
            defaultValue = col.value;
        }

        if (myCol.is_quantity_attribute && myCol.adjust_product_attribute) {
            const adjustableAttribute = this.props.productAttributesProp.find(item => item.id === myCol.adjust_product_attribute);
            const maxValueAllowed = col.original[adjustableAttribute.db_column];
            return (<div>
                    {
                        <input
                            className="form-control"
                            type={dataType}
                            style={{width: "80px"}}
                            onChange={e =>
                                this.changeHandler2(e, col.original.id, col.index)
                            }
                            value={defaultValue}
                            name={myCol.db_column}
                            id={`${myCol.db_column}-${col.index}`}
                            min="1"
                            max={maxValueAllowed}
                        />
                    }
                </div>
            );
        } else {
            return (<div>
                    {
                        <input
                            className="form-control"
                            type="text"
                            style={{width: "80px"}}
                            onChange={e =>
                                this.changeHandler2(e, col.original.id, col.index)
                            }
                            value={defaultValue}
                            name={myCol.db_column}
                            id={`${myCol.db_column}-${col.index}`}
                            //placeholder={myCol.sample_value}
                        />
                    }
                </div>
            );
        }
    }

    handleDeleteItem = (e, id) => {
        const mutated_array = this.state.products_data.map(item => {
            if (item.id === id) {
                item.selected = e.target.checked;
            }
            return item;
        })
        this.setState({
            products_data: mutated_array
        })
    }

    checkAll = (e) => {
        this.setState({
            all_checked: e.target.checked
        })
    }

    getColumns = (checkShowOnGrid) => {
        const filterdProductAttributes = checkShowOnGrid === 'true' ? this.props.productAttributesProp.filter(col => col.show_on_grid) : this.props.productAttributesProp;
        const columnArrays = filterdProductAttributes.map(col => {
            if (col.data_type === 'url') {
                return {
                    Header: col.grid_label,
                    title: col.title,
                    accessor: col.db_column,
                    excExp: true,
                    className: "action-center",
                    show: col.show_on_grid,
                    Cell: ({value}) => (
                        <React.Fragment>
                            <Link to={value} target="_blank" title="Download" download><img src={downloadIcon}
                                                                                            alt='img'/></Link>
                        </React.Fragment>
                    )
                };
            } else {
                return {
                    Header: col.grid_label,
                    title: col.title,
                    accessor: col.db_column,
                    className: "action-center",
                    excExp: col.exportable,
                    show: col.show_on_grid,
                };
            }
        });

        const orderColumnArrays = this.props.orderAttributesProp.map(myCol => {
            return {
                Header: myCol.cart_label,
                title: myCol.title,
                accessor: myCol.db_column,
                className: "action-center",
                Cell: (col) => this.genTblInput(col, myCol),
                excExp: true
            };
        });

        const allColumnsArrays = [
            ...columnArrays,
            {
                Header: 'Tag Layout',
                accessor: "tag_layout",
                excExp: true,
                Cell: ({value}) => (
                    <div>
                        {value ? value.title : ''}
                    </div>
                ),
                className: "action-center text-capitalize"
            },
            ...orderColumnArrays,
            {
                Header: (
                    <React.Fragment>
                        <div>
                            <label>
                                <span>Controls</span>
                            </label>
                            <span style={{paddingLeft: '5px'}}>
                                <input
                                    type="checkbox"
                                    checked={this.state.all_checked}
                                    style={{marginTop: '10px'}}
                                    onChange={this.checkAll}
                                />
                            </span>
                        </div>
                    </React.Fragment>
                ),
                minWidth: 120,
                sortable: false,
                accessor: "id",
                className: "action-center",
                Cell: ({value, original}) => (
                    <div>
                        <span
                            style={{paddingRight: '5px'}}
                        >
                            <input
                                type="checkbox"
                                checked={original.selected}
                                style={{marginTop: '10px'}}
                                onChange={(e) => {
                                    this.handleDeleteItem(e, value)
                                }}
                            />
                        </span>
                        {
                            <button
                                type="button"
                                className="deleteIcon orderDetailsAction"
                                onClick={() =>
                                    this.deleteConfirmListItem([value])
                                }
                            >
                                &nbsp;
                            </button>
                        }
                    </div>
                )
            }
        ];
        return allColumnsArrays;
    }

    downloadData = () => {
        this.props.getOrderProductsCall({
            cart: this.props.cart,
            brand: this.props.selectedBrand,
            filterTerm: '',
            page: 1,
            pageSize: -1
        }).then(response => {
            var data_to_download = []
            const columnsData = this.getColumns('false');
            for (var index = 0; index < this.props.products.length; index++) {
                let record_to_download = {}
                var temp = this.props.products[index];
                for (var colIndex = 0; colIndex < columnsData.length; colIndex++) {
                    if (columnsData[colIndex].excExp) {
                        if (this.state.exportAttsMap[columnsData[colIndex].title]) {
                            record_to_download[this.state.exportAttsMap[columnsData[colIndex].title]] = temp[columnsData[colIndex].accessor]

                        } else {
                            record_to_download[columnsData[colIndex].Header] = temp[columnsData[colIndex].accessor]
                        }
                    }
                    else if (columnsData[colIndex].accessor === "tag_layout") {
                        if (this.state.exportAttsMap[columnsData[colIndex].title]) {
                            record_to_download[this.state.exportAttsMap[columnsData[colIndex].title]] = temp[columnsData[colIndex].accessor] ? temp[columnsData[colIndex].accessor].title : ''
                        } else {
                            record_to_download[columnsData[colIndex].Header] = temp[columnsData[colIndex].accessor] ? temp[columnsData[colIndex].accessor].title : ''
                        }
                    }
                }
                data_to_download.push(record_to_download)
            }
            this.setState({dataToDownload: data_to_download}, () => {
                // this.csvLink.link.click()
            })
        });
    }

    componentDidMount() {
        let tempMap = { ...this.state.exportAttsMap };
        this.props.exportAttributes.forEach(item => {
            tempMap[item.title] = item.header_label
        })
        this.setState({
            ...this.state,
            all_columns: this.getColumns(),
            exportAttsMap: tempMap,

        }, () => {
            this.downloadData();
        });
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.productsData !== prevProps.productsData) {
            const mapped_arr = this.props.productsData.map(item => {
                return {
                    ...item,
                    selected: false
                }
            })
            this.setState({
                products_data: mapped_arr
            })
        }

        if (this.state.all_checked !== prevState.all_checked) {
            const mapped_arr = this.props.productsData.map(item => {
                return {
                    ...item,
                    selected: this.state.all_checked
                }
            })
            this.setState({
                products_data: mapped_arr
            })
        }
    }

    handleDeleteAllItems = () => {
        const delete_ids = [];
        this.state.products_data.filter(item => {
            if (item.selected) {
                delete_ids.push(item.id);
            }
        })
        this.deleteConfirmListItem(delete_ids, "Are you sure you want to delete the selected items?");
    }

    render() {
        const {filtered} = this.state;
        const {pages, loading} = this.props;
        const columns = [
            {
                Header: "States Listing",
                headerClassName: "headerPagination",
                columns: this.state.all_columns
            }
        ];

        return (
            <React.Fragment>
                <Col md={12} className="mt-sm" style={{marginBottom: 10}}>
                    <React.Fragment>
                        <div className="downloadCsv">
                            <CSVDownloader
                                data={this.state.dataToDownload}
                                ref={(r) => this.csvLink = r}
                                filename={"Cart_Products_" + moment().format('MMM/D/YYYY')}
                                config={{
                                    delimiter: '\t',
                                }}
                                bom={true}
                            >
                                <button type="button">
                                    Download
                                </button>
                            </CSVDownloader>
                        </div>
                        <div className="mt-md text-right">
                            <button type="button" onClick={this.handleDeleteAllItems} style={{maxWidth: '220px'}}
                                    className="customBtn btnBlack btn-lg">
                                Remove Selected
                            </button>
                        </div>

                    </React.Fragment>

                </Col>
                <Col md={12}>
                    <ReactTable
                        ref={(r) => this.reactTable = r}
                        noDataText="No data found"
                        data={this.state.products_data}
                        pages={pages}
                        loading={loading}
                        columns={columns}
                        filtered={filtered}
                        defaultPageSize={10}
                        className="resetTable listing responsive"
                        pageData={this.props.productsPaginationData}
                        manual
                        onFetchData={(state, instance) => {
                            var sort =
                                state.sorted.length === 0
                                    ? ""
                                    : state.sorted[0].id +
                                    ",desc:" +
                                    state.sorted[0].desc;
                            state.pageData(
                                state.page + 1,
                                this.props.filtered,
                                sort,
                                state.pageSize
                            );
                        }}
                    />
                </Col>
            </React.Fragment>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return ({
        getOrderProductsCall: (data) => {
            return dispatch(createOrderActions.getCartProductsPagination(data));
        },
    });
};

function mapStateToProps(state) {
    const {
        productsDataAll
    } = state.createOrdersReducer;

    return {
        products: productsDataAll
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ViewCartProductsList);



// WEBPACK FOOTER //
// ./src/components/Admin/Order/ViewCartProductsList.js